import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken, apiErr } from "@/lib/api";
import { Logo, Button, Field, Input } from "@/lib/ui";
import { useAuth } from "@/context/Auth";

export default function AdminLogin() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const [remember, setRemember] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("ds_remember_admin");
    if (saved) { setEmail(saved); setRemember(true); }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin/login", { email, password });
      if (remember) localStorage.setItem("ds_remember_admin", email);
      else localStorage.removeItem("ds_remember_admin");
      setToken(data.token);
      setUser(data.user);
      nav("/admin");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 fade-up">
        <Logo />
        <h1 className="mt-6 font-head text-2xl font-extrabold text-slate-900">Admin Panel</h1>
        <p className="mt-1 text-sm text-slate-500">Sign in to manage Deadstock.live.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <Field label="Email" required><Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          <Field label="Password" required>
            <div className="relative">
              <Input data-testid="admin-password" type={showPw ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className="pr-10" />
              <button type="button" onClick={() => setShowPw((v) => !v)} data-testid="admin-password-toggle" className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"><i className={`fa-solid ${showPw ? "fa-eye-slash" : "fa-eye"}`} /></button>
            </div>
          </Field>
          <label className="flex items-center gap-2 text-sm text-slate-600">
            <input type="checkbox" data-testid="admin-remember" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="h-4 w-4 accent-slate-900" />
            Remember me (stay signed in on this device)
          </label>
          <Button data-testid="admin-login-btn" type="submit" disabled={loading} variant="dark" className="w-full">{loading ? "Signing in…" : "Sign In"}</Button>
        </form>
        <button onClick={() => nav("/")} className="mt-4 text-xs font-semibold text-slate-400 hover:text-slate-600"><i className="fa-solid fa-chevron-left mr-1" /> Back to site</button>
      </div>
    </div>
  );
}
